module.exports = __webpack_public_path__ + "static/media/MW.9e69523c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/MW.svg
// module id = 322
// module chunks = 0